import httpService from './httpService';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface ChatResponse {
  reply: string;
  requestsLeft: number;
}

const aiService = {
  sendMessage: async (message: string, history: ChatMessage[]): Promise<ChatResponse> => {
    const { data } = await httpService.post<ChatResponse>('/ai/chat', { message, history });
    return data;
  },
};

export default aiService;
